// src/admin/pages/support/SupportHome.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function SupportHome() {
  return <Navigate to="/admin/support/users" replace />;
}
